import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'

interface Statistic {
  songs: number
  duration: number
  playlists: number
}

interface State extends Statistic {
}

export const initialState: Partial<State> = {
}

export const attemptGetStatistics = createAsyncThunk<any, void>(
  'statistics/get',
  async () => {
    const response = await $api.get('statistic/user')
    return response.data
  },
)

export const statisticsReducer = createSlice({
  name: 'statistics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptGetStatistics.fulfilled, (state, { payload }) => {
      state.songs = payload.songs
      state.duration = payload.duration
      state.playlists = payload.playlists
    })
  },
})

export const {} = statisticsReducer.actions
export default statisticsReducer.reducer
